import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({
  name: 'bpc-export-modal',
  components: {},
})
export default class ExportModal extends Vue {
  @Prop({ type: String, required: true }) readonly entityName: string;
  @Prop({ type: String, default: 'export-confirmation-modal' }) readonly modalId: string;
  @Prop({ type: Boolean, default: false }) readonly exportAllAllowed: boolean;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly loadingBulk: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Number, default: 200 }) readonly maxLimit: number;

  mounted() {
    if (this.showModal) {
      this.openModal();
    }
  }

  get exportModalTitle() {
    return this.$t('global.modals.export.title', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }

  get exportModalBody() {
    return this.$t('global.modals.export.body', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
    });
  }

  get exportAllModalBody() {
    return this.$t('global.modals.export_all.body', {
      entityName: this.$t('global.models.' + this.entityName + '.name'),
      entityPluralName: this.$t('global.models.' + this.entityName + '.pluralName'),
      thisEntityName: this.$t('global.models.' + this.entityName + '.thisName'),
      thisEntityPluralName: this.$t('global.models.' + this.entityName + '.thisPluralName'),
      maxLimit: this.maxLimit,
    });
  }
  closeModal() {
    this.$emit('close-modal');
  }

  openModal() {
    this.$bvModal.show(this.modalId);
  }
  onExportAll() {
    this.$emit('export-all-clicked');
  }
  onExport() {
    this.$emit('export-clicked');
  }

  @Watch('showModal')
  onShowModalChange(val) {
    if (val) {
      this.openModal();
    } else {
      this.$bvModal.hide(this.modalId);
    }
  }

  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
